// extracted by mini-css-extract-plugin
export var text = "_ac-0";